import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './LandingPageLayout.css';

interface ILandingPageLayoutProps extends React.PropsWithChildren {
  isWebView: boolean;
}

export const LandingPageLayout: React.FC<ILandingPageLayoutProps> = ({ children, isWebView }) => {
  return <div className={clsx(styles['page'], isWebView && styles['webview'])}>{children}</div>;
};
